import { render, staticRenderFns } from "./buxiugangMain.vue?vue&type=template&id=933a262a&scoped=true"
import script from "./buxiugangMain.vue?vue&type=script&lang=js"
export * from "./buxiugangMain.vue?vue&type=script&lang=js"
import style0 from "./buxiugangMain.vue?vue&type=style&index=0&id=933a262a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933a262a",
  null
  
)

export default component.exports